import React, { Fragment, useEffect, useState } from 'react';
import { Button, Checkbox, Col, Divider, Form, Icon, Input, Modal, Radio, Row, Switch } from "antd";
import { GUTTER_MD, GUTTER_SM, MARGIN_MD, MODAL_WIDTH_LG, MODAL_WIDTH_SM, SPAN_FULL, SPAN_ONE_THIRD, SPAN_TWO_THIRDS, TABLE_COL_MIN_WIDTH_ID } from "../../../../styles/constants";
import Call from '../../../../hocs/call';
import {
  changeDataflowBuilderListDataflowContentConstraintIsAllowed,
  changeDataflowBuilderListDataflowTranscodingMode,
  changeVerifyTimePeriodFormat,
  deleteDataflowProductionModalDDBContentConstraints,
  forceDataflowBuilderListDataflowCacheUpdate,
  hideDataflowBuilderListDataflowProductionModal,
  hideDataflowBuilderListDataflowTranscodingFromCCList,
  readDataflowBuilderListDataflowTranscodingFromCCList,
  readDataflowBuilderListonDataflowMappingSetId,
  readDataflowProductionModalDataflowContentConstraints,
  setDataflowBuilderListDataflowContentConstraint,
  setDataflowBuilderListDataflowMappingSet,
  setDataflowBuilderListDataflowProductionFlag,
  setDataflowBuilderListDataflowTranscoding,
  setDataflowBuilderListDataflowTranscodingFromCC,
  setDataflowBuilderListDataflowTranscodingFromCCContentConstraint,
  showDataflowBuilderListDataflowTranscodingFromCCList,
  unsetDataflowBuilderListDataflowContentConstraint,
  unsetDataflowBuilderListDataflowMappingSet,
  unsetDataflowBuilderListDataflowTranscoding,
  unsetDataflowBuilderListDataflowTranscodingFromCCContentConstraint,
  showTranscodingModal,
  hideTranscodingModal,
  setComponentsList,
  getEncodableArtefactsList,
  setShowTranscodingCCRows,
  DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET
} from "./actions";
import { compose } from "redux";
import { connect } from "react-redux";
import { translate } from 'react-i18next';
import EnhancedModal from '../../../../components/enhanced-modal';
import { DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO, DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC } from "./reducer";
import Selector from "../../../../components/selector";
import { getArtefactTripletFromString, getStringFromArtefactTriplet } from "../../../../utils/sdmxJson";
import ArtefactList from "../../../../components/artefact-list";
import { getDataflowDDBContentConstraint } from './utils';
import { DATAFLOW_BUILDER_CONTENT_CONSTRAINT_PREFIX } from './reducer';
import ReduxContentConstraintDetailModal from "../../../../redux-components/redux-content-constraint-modal";
import { createContentConstraintDetail, editContentConstraintDetail } from '../../../../redux-components/redux-content-constraint-modal/actions';
import { reuseAction } from '../../../../utils/reduxReuse';
import { CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW } from '../../../../redux-components/redux-content-constraint-modal/FilterTab';
import { AUTO_ANNOTATION_DDB_CONTENT_CONSTRAINT_KEY } from '../../../../utils/annotations';
import InfiniteScrollTable from '../../../../components/infinite-scroll-table';

const labelStyle = {
  fontSize: 14,
  fontWeight: 500,
  color: "rgba(0,0,0,0.85)"
};

const disabledLabelStyle = {
  fontSize: 14,
  fontWeight: 500,
  color: "rgba(0,0,0,0.35)"
};

const mapStateToProps = state => ({
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  dataflows: state.scenes.dataManager.dataflowBuilder.shared.dataflows,
  isMappingSetIdToUpdate: state.scenes.dataManager.dataflowBuilder.shared.isMappingSetIdToUpdate,
  dataflowProductionModalDDBDataflowId: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalDDBDataflowId,
  dataflowProductionModalDataflowTriplet: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalDataflowTriplet,
  dataflowProductionModalMappingSetId: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalMappingSetId,
  dataflowProductionModalTranscodingMode: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalTranscodingMode,
  dataflowProductionModalTranscodingContentConstraintTriplet: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalTranscodingContentConstraintTriplet,
  isDataflowProductionModalTranscodingContentConstraintListVisible: state.scenes.dataManager.dataflowBuilder.components.list.isDataflowProductionModalTranscodingContentConstraintListVisible,
  dataflowProductionModalTranscodingContentConstraints: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalTranscodingContentConstraints,
  dataflowProductionModalContentConstraintIsAllowed: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalContentConstraintIsAllowed,
  verifyTimePeriodFormat: state.scenes.dataManager.dataflowBuilder.components.list.verifyTimePeriodFormat,
  dataflowProductionModalContentConstraints: state.scenes.dataManager.dataflowBuilder.components.list.dataflowProductionModalContentConstraints,
  enabledFetchDataflowProductionModalContentConstraints: state.scenes.dataManager.dataflowBuilder.components.list.enabledFetchDataflowProductionModalContentConstraints,
  contentConstraintDetail: state.scenes.dataManager.dataflowBuilder.components.list.contentConstraintDetail,
  cubeId: state.scenes.dataManager.dataflowBuilder.components.list.cubeId,
  showModal: state.scenes.dataManager.dataflowBuilder.components.list.showModal,
  componentsList: state.scenes.dataManager.dataflowBuilder.components.list.componentsList,
  encodeableArtefactsList: state.scenes.dataManager.dataflowBuilder.components.list.encodeableArtefacts,
  showTranscodingCCRows: state.scenes.dataManager.dataflowBuilder.shared.showTranscodingCCRows,
  hasDABCheckFailed: state.scenes.dataManager.dataflowBuilder.shared.hasDABCheckFailed,
  notProductionFlag: state.scenes.dataManager.dataflowBuilder.shared.notProductionFlag,
  dabCheckFailedAction: state.scenes.dataManager.dataflowBuilder.shared.dabCheckFailedAction,
});

const mapDispatchToProps = dispatch => ({
  onMappingSetCreate:
    (ddbDataflowId, defaultValue) => dispatch(setDataflowBuilderListDataflowMappingSet(ddbDataflowId, defaultValue)),
  onMappingSetDelete: (ddbDataflowId, check) => dispatch(unsetDataflowBuilderListDataflowMappingSet(ddbDataflowId, check)),
  onTranscodingModeChange: mode => dispatch(changeDataflowBuilderListDataflowTranscodingMode(mode)),
  onTranscodingFromCCContentConstraintSet: contentConstraintTriplet => dispatch(setDataflowBuilderListDataflowTranscodingFromCCContentConstraint(contentConstraintTriplet)),
  onTranscodingFromCCContentConstraintUnset: () => dispatch(unsetDataflowBuilderListDataflowTranscodingFromCCContentConstraint()),
  onTranscodingCreate: (ddbDataflowId, checkTimeFormat, componentsList) => dispatch(setDataflowBuilderListDataflowTranscoding(ddbDataflowId, checkTimeFormat, componentsList)),
  onTranscodingFromCCCreate: (ddbDataflowId, contentConstraintTriplet, checkTimeFormat) =>
    dispatch(setDataflowBuilderListDataflowTranscodingFromCC(ddbDataflowId, contentConstraintTriplet, checkTimeFormat)),
  onTranscodingFromCCListShow: () => dispatch(showDataflowBuilderListDataflowTranscodingFromCCList()),
  onTranscodingFromCCListHide: () => dispatch(hideDataflowBuilderListDataflowTranscodingFromCCList()),
  onTranscodingDelete: ddbDataflowId => dispatch(unsetDataflowBuilderListDataflowTranscoding(ddbDataflowId)),
  onIsAllowedChange: isAllowed => dispatch(changeDataflowBuilderListDataflowContentConstraintIsAllowed(isAllowed)),
  onContentConstraintCreate: (ddbDataflowId, isAllowed) => dispatch(setDataflowBuilderListDataflowContentConstraint(ddbDataflowId, isAllowed)),
  onContentConstraintDelete:
    ddbDataflowId => dispatch(unsetDataflowBuilderListDataflowContentConstraint(ddbDataflowId)),
  onSetProductionFlag: (ddbDataflowId, isProduction, check) =>
    dispatch(setDataflowBuilderListDataflowProductionFlag(ddbDataflowId, isProduction, check)),
  onForceCacheUpdate: dataflowTriplet => dispatch(forceDataflowBuilderListDataflowCacheUpdate(dataflowTriplet)),
  onHide: () => dispatch(hideDataflowBuilderListDataflowProductionModal()),
  fetchDataflowMappingSetId: ddbDataflowId => dispatch(readDataflowBuilderListonDataflowMappingSetId(ddbDataflowId)),
  fetchTranscodingFromCCList: cubeId => dispatch(readDataflowBuilderListDataflowTranscodingFromCCList(cubeId)),
  onChangeVerifyTimePeriodFormat: verifyTimePeriodFormatChecked =>
    dispatch(changeVerifyTimePeriodFormat(verifyTimePeriodFormatChecked)),
  fetchDataflowProductionModalDataflowContentConstraints: dataflowTriplet =>
    dispatch(readDataflowProductionModalDataflowContentConstraints(dataflowTriplet)),
  onCreateDDBConstraintShow: (dataflowTriplet) =>
    dispatch(reuseAction(createContentConstraintDetail(CONTENT_CONSTRAINTS_ARTEFACT_TYPE_DATAFLOW, dataflowTriplet,
      AUTO_ANNOTATION_DDB_CONTENT_CONSTRAINT_KEY), DATAFLOW_BUILDER_CONTENT_CONSTRAINT_PREFIX)),
  onUpdateDDBConstraintShow: (contentConstraintTriplet) =>
    dispatch(reuseAction(editContentConstraintDetail(contentConstraintTriplet), DATAFLOW_BUILDER_CONTENT_CONSTRAINT_PREFIX)),
  onDDBContentConstraintDelete: (constraintTriplet) => dispatch(deleteDataflowProductionModalDDBContentConstraints(constraintTriplet)),
  onModalTranscodingShow: () => dispatch(showTranscodingModal()),
  onModalTranscodingHide: () => dispatch(hideTranscodingModal()),
  setComponentsList: (componentsList) => dispatch(setComponentsList(componentsList)),
  encodeableArtefacts: (dfId) => dispatch(getEncodableArtefactsList(dfId)),
  onSetTranscodingCCRows: (show) => dispatch(setShowTranscodingCCRows(show))
});

const formItemLayout = {
  labelCol: { span: SPAN_ONE_THIRD },
  wrapperCol: { span: SPAN_TWO_THIRDS }
};

const CreateMappingSetForm = Form.create()(
  ({ form, t, modal, onMappingSetCreate }) =>
    <Form>
      <Row style={{ marginBottom: MARGIN_MD, marginTop: MARGIN_MD }}>
        <Col span={SPAN_FULL}>
          <Form.Item
            {...formItemLayout}
            label={t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.defaultValue.label")}
          >
            {form.getFieldDecorator('defaultValue')(<Input />)}
          </Form.Item>
        </Col>
      </Row>
      <Row type="flex" style={{ marginTop: MARGIN_MD }} justify="end" gutter={GUTTER_MD}>
        <Col>
          <Button onClick={() => modal.destroy()}>
            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.cancelButton.title")}
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={
              () => {
                modal.destroy();
                onMappingSetCreate(form.getFieldValue('defaultValue'))
              }
            }
          >
            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.okButton.title")}
          </Button>
        </Col>
      </Row>
    </Form>
);

const DataflowBuilderListDataflowProductionModal = ({
  t,
  endpoints,
  endpointId,
  dataflows,
  isMappingSetIdToUpdate,
  dataflowProductionModalDDBDataflowId,
  dataflowProductionModalDataflowTriplet,
  dataflowProductionModalMappingSetId,
  onMappingSetCreate,
  onMappingSetDelete,
  dataflowProductionModalTranscodingMode,
  dataflowProductionModalTranscodingContentConstraintTriplet,
  isDataflowProductionModalTranscodingContentConstraintListVisible,
  onTranscodingModeChange,
  onTranscodingFromCCListShow,
  onTranscodingFromCCListHide,
  dataflowProductionModalTranscodingContentConstraints,
  dataflowProductionModalContentConstraintIsAllowed,
  dataflowProductionModalContentConstraints,
  enabledFetchDataflowProductionModalContentConstraints,
  contentConstraintDetail,
  verifyTimePeriodFormat,
  onTranscodingFromCCContentConstraintSet,
  onTranscodingFromCCContentConstraintUnset,
  onTranscodingFromCCCreate,
  onTranscodingCreate,
  onTranscodingDelete,
  onIsAllowedChange,
  onContentConstraintCreate,
  onContentConstraintDelete,
  onSetProductionFlag,
  onForceCacheUpdate,
  onHide,
  fetchDataflowMappingSetId,
  fetchTranscodingFromCCList,
  onChangeVerifyTimePeriodFormat,
  fetchDataflowProductionModalDataflowContentConstraints,
  onCreateDDBConstraintShow,
  onUpdateDDBConstraintShow,
  onDDBContentConstraintDelete,
  cubeId,
  onModalTranscodingShow,
  onModalTranscodingHide,
  showModal,
  setComponentsList,
  componentsList,
  encodeableArtefacts,
  showTranscodingCCRows,
  encodeableArtefactsList,
  onSetTranscodingCCRows,
  hasDABCheckFailed,
  notProductionFlag,
  dabCheckFailedAction
}) => {

  useEffect(() => {
    if(hasDABCheckFailed === true) {
      Modal.confirm({
        title: t('errors.modals.DATABROWSER_NOT_CONFIGURED.title'),
        content: t('errors.modals.DATABROWSER_NOT_CONFIGURED.content'),
        onOk() {
          if(dabCheckFailedAction === DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET) {
            onSetProductionFlag(dataflowProductionModalDataflow.IDDataflow, notProductionFlag, false)
          } else {
            onMappingSetDelete(dataflowProductionModalDataflow.IDDataflow, false)
          }
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    }
  }, [hasDABCheckFailed]);

  const isComponentsListEmpty = !componentsList.length
  const rowSelection = {
    selectedRowKeys: componentsList,
    onChange: setComponentsList,
  }

  const dataflowProductionModalDataflow =
    dataflows && dataflowProductionModalDDBDataflowId
      ? dataflows.filter(df => df.IDDataflow === dataflowProductionModalDDBDataflowId)[0]
      : null;

  const node = endpoints.find(endpoint => endpoint.general.id === endpointId);
  const dataflowDDBContentConstraint = getDataflowDDBContentConstraint(dataflowProductionModalDataflow, dataflowProductionModalContentConstraints, node.annotations);
  const hasDDBContentConstraint = dataflowDDBContentConstraint !== null;

  const canCreateAutomaticCC = dataflowProductionModalDataflow !== null &&
    dataflowProductionModalMappingSetId !== undefined &&
    dataflowProductionModalMappingSetId !== null &&
    dataflowProductionModalDataflow.HasTranscoding &&
    !dataflowProductionModalDataflow.HasContentConstraints;

  const dataflowHasAutomaticCC = dataflowProductionModalDataflow !== null &&
    dataflowProductionModalMappingSetId !== undefined &&
    dataflowProductionModalMappingSetId !== null &&
    dataflowProductionModalDataflow.HasTranscoding &&
    dataflowProductionModalDataflow.HasContentConstraints &&
    !hasDDBContentConstraint;

  const canCreateDdbCC = dataflowProductionModalDataflow !== null &&
    !dataflowProductionModalDataflow.HasContentConstraints;

  const checkSwitch = (status) => {
    if(status) {
      return Modal.confirm({
        title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.switchTranscodingCC.body"),
        onOk() {
          onSetTranscodingCCRows(true);
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    } else {
      return onSetTranscodingCCRows(false);
    }
  }

  return (
    <Fragment>

      <Call
        cb={fetchDataflowMappingSetId}
        cbParam={dataflowProductionModalDataflow !== null ? dataflowProductionModalDataflow.IDDataflow : null}
        disabled={dataflowProductionModalDataflow === null}
      >
        <Call
          cb={fetchDataflowMappingSetId}
          cbParam={dataflowProductionModalDataflow !== null ? dataflowProductionModalDataflow.IDDataflow : null}
          disabled={isMappingSetIdToUpdate === false}
        >
          <Call
            cb={fetchDataflowProductionModalDataflowContentConstraints}
            cbParam={dataflowProductionModalDataflowTriplet}
            disabled={dataflowProductionModalDataflowTriplet === null ||
              dataflowProductionModalDataflow === null ||
              !enabledFetchDataflowProductionModalContentConstraints
            }
          >
            <EnhancedModal
              visible={dataflowProductionModalDDBDataflowId !== null}
              onCancel={onHide}
              footer={
                <Button onClick={onHide}>
                  {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.close.title")}
                </Button>
              }
              width={MODAL_WIDTH_LG}
              title={t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.title', {
                id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
              })}
            >
              <Fragment>
                <Row justify="space-between" type="flex" style={{ marginBottom: MARGIN_MD }}>
                  <Col style={labelStyle}>
                    {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.label")}
                  </Col>
                  <Col>
                    <Row gutter={GUTTER_SM} justify="end" type="flex">
                      <Col>
                        <Button
                          disabled={
                            dataflowProductionModalMappingSetId === undefined ||
                            dataflowProductionModalDataflow === null ||
                            dataflowProductionModalMappingSetId !== null
                          }
                          size="small"
                          type="primary"
                          onClick={
                            () => {
                              let modal = Modal.confirm();
                              modal.update({
                                title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.confirm.title", {
                                  id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                                }),
                                content:
                                  <CreateMappingSetForm
                                    t={t}
                                    modal={modal}
                                    onMappingSetCreate={
                                      defaultValue =>
                                        onMappingSetCreate(dataflowProductionModalDataflow.IDDataflow, defaultValue)
                                    }
                                  />,
                                okButtonProps: { style: { display: 'none' } },
                                cancelButtonProps: { style: { display: 'none' } },
                              })
                            }
                          }>
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.createButton.title")}
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          disabled={
                            dataflowProductionModalDataflow === null || dataflowProductionModalMappingSetId === null || dataflowProductionModalMappingSetId === undefined}
                          size="small"
                          type="primary"
                          onClick={
                            () => Modal.confirm({
                              title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.deleteButton.confirm.title", {
                                id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                              }),
                              onOk() {
                                onMappingSetDelete(dataflowProductionModalDataflow.IDDataflow, true);
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                        >
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.mappingSet.deleteButton.title")}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Divider />
                <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                  <Col style={labelStyle}>
                    {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.switchTranscodingCC.title")}
                  </Col>
                  <Col>
                    <Row gutter={GUTTER_SM} type="flex" justify="end">
                      <Switch
                        onChange={checkSwitch}
                        checked={showTranscodingCCRows}
                        disabled={dataflowProductionModalDataflow ? dataflowProductionModalDataflow.HasTranscoding : false}
                        size="medium"
                      />
                    </Row>
                  </Col>
                </Row>
                {showTranscodingCCRows
                  ? (
                    <>
                      {/* TRANSCODING ROW */}
                      <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                        <Col style={dataflowProductionModalMappingSetId !== null ? labelStyle : disabledLabelStyle}>
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.label")}
                        </Col>
                      </Row>
                      <Row justify="space-between" type="flex">
                        <Col>
                          <Row gutter={GUTTER_SM} type="flex">
                            <Col>
                              <Radio.Group
                                value={(
                                  dataflowProductionModalMappingSetId === null ||
                                  dataflowProductionModalMappingSetId === undefined ||
                                  (dataflowProductionModalDataflow && dataflowProductionModalDataflow.HasTranscoding)
                                )
                                  ? null
                                  : dataflowProductionModalTranscodingMode
                                }
                                onChange={({ target }) => onTranscodingModeChange(target.value)}
                                size="small"
                                disabled={
                                  dataflowProductionModalMappingSetId === null ||
                                  dataflowProductionModalMappingSetId === undefined ||
                                  (dataflowProductionModalDataflow && dataflowProductionModalDataflow.HasTranscoding)
                                }
                              >
                                <Radio.Button
                                  value={DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO}
                                >
                                  {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingRadio.auto.title")}
                                </Radio.Button>
                                <Radio.Button
                                  value={DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC}
                                >
                                  {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingRadio.fromContentConstraint.title")}
                                </Radio.Button>
                              </Radio.Group>
                            </Col>
                            <Col>
                              {dataflowProductionModalTranscodingMode === DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC &&
                                dataflowProductionModalMappingSetId !== null &&
                                dataflowProductionModalMappingSetId !== undefined &&
                                dataflowProductionModalDataflow &&
                                !dataflowProductionModalDataflow.HasTranscoding && (
                                  <Fragment>
                                    <Selector
                                      selectTitle={t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingCCSelector.select.title")}
                                      resetTitle={t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.transcodingCCSelector.reset.title")}
                                      onSelect={onTranscodingFromCCListShow}
                                      onReset={onTranscodingFromCCContentConstraintUnset}
                                      value={
                                        dataflowProductionModalTranscodingContentConstraintTriplet
                                          ? getStringFromArtefactTriplet(dataflowProductionModalTranscodingContentConstraintTriplet)
                                          : null
                                      }
                                      size="small"
                                    >
                                      {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.selectButton.title")}
                                    </Selector>
                                    <EnhancedModal
                                      visible={isDataflowProductionModalTranscodingContentConstraintListVisible}
                                      title={t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcodingContentConstraintList.title")}
                                      onCancel={onTranscodingFromCCListHide}
                                      footer={<Button
                                        onClick={onTranscodingFromCCListHide}>{t('commons.buttons.close.title')}</Button>}
                                      width={MODAL_WIDTH_LG}
                                    >
                                      <Call
                                        cb={fetchTranscodingFromCCList}
                                        cbParam={dataflows.find(item => item.IDDataflow === dataflowProductionModalDDBDataflowId).IDCube}
                                        disabled={!isDataflowProductionModalTranscodingContentConstraintListVisible}
                                      >
                                        <ArtefactList
                                          artefacts={dataflowProductionModalTranscodingContentConstraints}
                                          onRowClick={
                                            ({ id, agencyID, version }) => onTranscodingFromCCContentConstraintSet({
                                              id,
                                              agencyID,
                                              version
                                            })}
                                        />
                                      </Call>
                                    </EnhancedModal>
                                  </Fragment>
                                )}
                            </Col>
                            <Col>
                              <Checkbox
                                checked={verifyTimePeriodFormat}
                                onChange={e => onChangeVerifyTimePeriodFormat(e.target.checked)}
                              >
                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.checkTimePeriodFormat.label")}
                              </Checkbox>
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row gutter={GUTTER_SM} type="flex" justify="end">
                            <Col>
                              <Fragment>
                                <Button
                                  disabled={
                                    dataflowProductionModalDataflow === null ||
                                    dataflowProductionModalMappingSetId === null ||
                                    dataflowProductionModalMappingSetId === undefined ||
                                    dataflowProductionModalDataflow.HasTranscoding ||
                                    (
                                      dataflowProductionModalTranscodingMode === DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_CC &&
                                      dataflowProductionModalTranscodingContentConstraintTriplet === null
                                    )
                                  }
                                  size="small"
                                  type="primary"
                                  onClick={() => {
                                    onModalTranscodingShow()
                                    encodeableArtefacts(dataflowProductionModalDDBDataflowId)
                                  }
                                  }
                                >
                                  {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.createButton.title")}
                                </Button>
                                <EnhancedModal
                                  visible={showModal}
                                  title={t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.title", {
                                    id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                                  })}
                                  onCancel={onModalTranscodingHide}
                                  footer={
                                    <Fragment>
                                      <Button onClick={onModalTranscodingHide}>
                                        {t('commons.buttons.cancel.title')}
                                      </Button>
                                      <Button type='primary' onClick={() => {
                                        if (dataflowProductionModalTranscodingMode === DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_MODAL_MODE_AUTO) {
                                          onTranscodingCreate(dataflowProductionModalDataflow.IDDataflow, verifyTimePeriodFormat, componentsList);
                                        } else {
                                          onTranscodingFromCCCreate(dataflowProductionModalDataflow.IDDataflow, dataflowProductionModalTranscodingContentConstraintTriplet, verifyTimePeriodFormat)
                                        }
                                      }
                                      }>
                                        {t('commons.buttons.ok.title')}
                                      </Button>
                                    </Fragment>
                                  }
                                  width={MODAL_WIDTH_SM}
                                >
                                  <Row className='transcoding-modal-body'>
                                    <Col className='transcoding-modal-description'>
                                      {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.description")}
                                    </Col>
                                    <Col>
                                      <InfiniteScrollTable
                                        hideHeader
                                        hideFooter
                                        data={encodeableArtefactsList}
                                        getRowKey={({ cube }) => cube}
                                        columns={[
                                          {
                                            title: t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.table.columns.codedComponents'),
                                            dataIndex: 'cube',
                                            minWidth: TABLE_COL_MIN_WIDTH_ID,
                                            noFilter: true,
                                            noSort: true
                                          }
                                        ]}
                                        rowSelection={rowSelection}
                                        multilangStrDataIndexes={['labels']}
                                      
                                      />
                                    </Col>
                                    <Divider />
                                    <Col className='transcoding-modal-warning-text'>
                                      <Icon type="question-circle" className='icon' />
                                      {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.createButton.confirm.title", {
                                        id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                                      })}
                                    </Col>
                                  </Row>
                                </EnhancedModal>
                              </Fragment>
                            </Col>
                            <Col>
                              <Button
                                disabled={
                                  dataflowProductionModalDataflow === null ||
                                  dataflowProductionModalMappingSetId === null ||
                                  dataflowProductionModalMappingSetId === undefined ||
                                  !dataflowProductionModalDataflow.HasTranscoding
                                }
                                size="small"
                                type="primary"
                                onClick={
                                  () => Modal.confirm({
                                    title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.deleteButton.confirm.title", {
                                      id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                                    }),
                                    onOk() {
                                      onTranscodingDelete(dataflowProductionModalDataflow.IDDataflow);
                                    },
                                    cancelText: t('commons.buttons.cancel.title')
                                  })
                                }
                              >
                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.deleteButton.title")}
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Divider />
                      <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                        <Col
                          style={
                            (canCreateAutomaticCC || dataflowHasAutomaticCC)
                              ? labelStyle
                              : disabledLabelStyle
                          }
                        >
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.label")}
                        </Col>
                      </Row>
                      <Row justify="space-between" type="flex">
                        <Col>
                          <Radio.Group
                            value={(canCreateAutomaticCC)
                              ? dataflowProductionModalContentConstraintIsAllowed
                              : null
                            }
                            onChange={({ target }) => onIsAllowedChange(target.value)}
                            size="small"
                            disabled={!canCreateAutomaticCC}
                          >
                            <Radio.Button value={true}>
                              {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.contentConstraintRadio.allowed.title")}
                            </Radio.Button>
                            <Radio.Button value={false}>
                              {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.buttons.contentConstraintRadio.actual.title")}
                            </Radio.Button>
                          </Radio.Group>
                        </Col>
                        <Col>
                          <Row gutter={GUTTER_SM} justify="end" type="flex">
                            <Col>
                              <Button
                                disabled={!canCreateAutomaticCC}
                                size="small"
                                type="primary"
                                onClick={
                                  () => Modal.confirm({
                                    title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.createButton.confirm.title", {
                                      id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                                    }),
                                    onOk() {
                                      onContentConstraintCreate(dataflowProductionModalDataflow.IDDataflow, dataflowProductionModalContentConstraintIsAllowed);
                                    },
                                    cancelText: t('commons.buttons.cancel.title')
                                  })
                                }
                              >
                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.createButton.title")}
                              </Button>
                            </Col>
                            <Col>
                              <Button
                                disabled={!dataflowHasAutomaticCC}
                                size="small"
                                type="primary"
                                onClick={
                                  () => Modal.confirm({
                                    title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.deleteButton.confirm.title", {
                                      id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                                    }),
                                    onOk() {
                                      onContentConstraintDelete(dataflowProductionModalDataflow.IDDataflow);
                                    },
                                    cancelText: t('commons.buttons.cancel.title')
                                  })
                                }
                              >
                                {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.contentConstraint.deleteButton.title")}
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )
                  : null
                }
                <Divider />
                <Row gutter={GUTTER_MD} justify="space-between" type="flex">
                  <Col
                    style={
                      dataflowProductionModalDataflow !== null &&
                        (
                          dataflowProductionModalMappingSetId !== null ||
                          dataflowProductionModalDataflow.HasTranscoding ||
                          dataflowProductionModalDataflow.hasContentConstraint
                        )
                        ? labelStyle
                        : disabledLabelStyle
                    }
                  >
                    {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.label")}
                  </Col>
                  <Col>
                    <Row gutter={GUTTER_SM} justify="end" type="flex">
                      <Col>
                        <Button
                          disabled={
                            dataflowProductionModalDataflow === null ||
                            dataflowProductionModalMappingSetId === undefined ||
                            (
                              dataflowProductionModalMappingSetId === null &&
                              !dataflowProductionModalDataflow.HasTranscoding &&
                              !dataflowProductionModalDataflow.hasContentConstraint
                            ) ||
                            dataflowProductionModalDataflow.isProduction
                          }
                          size="small"
                          type="primary"
                          onClick={
                            () => Modal.confirm({
                              title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.publishButton.confirm.title", {
                                id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                              }),
                              onOk() {
                                onSetProductionFlag(dataflowProductionModalDataflow.IDDataflow, false, true);
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                        >
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.publishButton.title")}
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          disabled={
                            dataflowProductionModalDataflow === null ||
                            dataflowProductionModalMappingSetId === undefined ||
                            (
                              dataflowProductionModalMappingSetId === null &&
                              !dataflowProductionModalDataflow.HasTranscoding &&
                              !dataflowProductionModalDataflow.hasContentConstraint
                            ) || !dataflowProductionModalDataflow.isProduction
                          }
                          size="small"
                          type="primary"
                          onClick={
                            () => Modal.confirm({
                              title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.removeButton.confirm.title", {
                                id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                              }),
                              onOk() {
                                onSetProductionFlag(dataflowProductionModalDataflow.IDDataflow, true, true);
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                        >
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.production.removeButton.title")}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Divider />
                <Row gutter={GUTTER_MD} justify="space-between" type="flex">
                  <Col
                    style={
                      (canCreateDdbCC || hasDDBContentConstraint)
                        ? labelStyle
                        : disabledLabelStyle
                    }
                  >
                    {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.label")}
                  </Col>
                  <Col>
                    <Row gutter={GUTTER_SM} justify="end" type="flex">

                      <Col>
                        {!hasDDBContentConstraint && (
                          <Button
                            disabled={!canCreateDdbCC}
                            size="small"
                            type="primary"
                            onClick={
                              () => Modal.confirm({
                                title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.createButton.confirm.title", {
                                  id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                                }),
                                onOk() {
                                  onCreateDDBConstraintShow(dataflowProductionModalDataflowTriplet);
                                },
                                cancelText: t('commons.buttons.cancel.title')
                              })
                            }>
                            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.createButton.title")}
                          </Button>
                        )}
                        {hasDDBContentConstraint && (
                          <Button
                            size="small"
                            type="primary"
                            onClick={
                              //   () => Modal.confirm({
                              //     title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.updateButton.confirm.title", {
                              //       id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                              //     }),
                              //     onOk() {
                              //       onUpdateDDBConstraintShow(getArtefactTripletFromString(getStringFromArtefactTriplet(dataflowDDBContentConstraint)));
                              //     },
                              //     cancelText: t('commons.buttons.cancel.title')
                              //   })
                              () => onUpdateDDBConstraintShow(getArtefactTripletFromString(getStringFromArtefactTriplet(dataflowDDBContentConstraint)))
                            }
                          >
                            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.updateButton.title")}
                          </Button>
                        )}
                      </Col>

                      <Col>
                        <Button
                          disabled={!hasDDBContentConstraint}
                          size="small"
                          type="primary"
                          onClick={
                            () => Modal.confirm({
                              title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.deleteButton.confirm.title", {
                                id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                              }),
                              onOk() {
                                onDDBContentConstraintDelete(getArtefactTripletFromString(getStringFromArtefactTriplet(dataflowDDBContentConstraint)));
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                        >
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.ddbContentConstraint.deleteButton.title")}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                                 

                {(endpoints.find(endpoint => endpoint.general.id === endpointId).dataBrowser || {}).enable && (
                  <Fragment>
                    <Divider />
                    <Row gutter={GUTTER_MD} justify="space-between" type="flex">
                      <Col style={labelStyle}>
                        {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.label")}
                      </Col>
                      <Col>
                        <Button
                          disabled={dataflowProductionModalDataflow === null || dataflowProductionModalMappingSetId === undefined}
                          size="small"
                          type="primary"
                          onClick={
                            () => Modal.confirm({
                              title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.forceCacheUpdateButton.confirm.title", {
                                id: dataflowProductionModalDataflow ? dataflowProductionModalDataflow.ID : ""
                              }),
                              onOk() {
                                onForceCacheUpdate(dataflowProductionModalDataflowTriplet);
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          }
                        >
                          {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.forceCacheUpdate.forceCacheUpdateButton.title")}
                        </Button>
                      </Col>
                    </Row>
                  </Fragment>
                )}
              </Fragment>
            </EnhancedModal>

          </Call>
        </Call>
      </Call>

      <ReduxContentConstraintDetailModal
        instancePrefix={DATAFLOW_BUILDER_CONTENT_CONSTRAINT_PREFIX}
        instanceState={contentConstraintDetail}
        isArtefactSelectorDisabled={true}
        cubeId={cubeId}
        isDdbDataflow={true}
        dataflowId={dataflowProductionModalDDBDataflowId}
        isEditEnabledOnlyFromBuilder={true}
      />
    </Fragment>
  );
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
)(DataflowBuilderListDataflowProductionModal);
